import { html, strMap } from 'fxjs/es';
import { MuiF } from '../../../../Mui/F/Function/module/MuiF.js';
import { UtilF } from '../../../../Util/F/Function/module/UtilF.js';
import { FramesTabStyleFMuiF } from '@modules/Frames/TabStyle/F/Mui/module/FramesTabStyleMuiF.js';
import { FramesTabStyleConstantS } from '@modules/Frames/TabStyle/S/Constant/module/FramesTabStyleConstantS.js';

export const openInfo = async ({
  tab_names,
  selected_name,
  type,
  info: { description, content },
  bp_id,
  bp_name,
}) => {
  return MuiF.openFrame(FramesTabStyleFMuiF.frame, (frame, page, [tab]) => {
    frame.hide_frame_button_type = 'X';
    const is_mobile = UtilF.isLegacyMobile();
    frame.prev_frame_show = false;
    frame.is_modal = !is_mobile;
    frame.always_remove = true;
    frame.attrs = {
      modal_title: type,
    };
    const { title, tabs } = FramesTabStyleConstantS.infos(type)[type];
    page.custom_header = () => {
      return html`<div class="modal_title" style="${is_mobile || !description ? 'padding-left:12px' : ''}">
          ${title}
        </div>
        ${description
          ? html`<div class="modal_description">
              ${is_mobile
                ? html`<div class="modal_description__content">${description.content}</div>
                    <div class="modal_description__title">${description.title}</div> `
                : html`<div class="modal_description__title">${description.title}</div>
                    <div class="modal_description__content">${description.content}</div>`}
            </div>`
          : ''} `;
    };

    tab.makeData = () => ({ selected_name });
    tab.template = ({ selected_name }) => {
      return html`
        <div class="modal_wrapper">
          <div class="modal_side ${description ? '' : 'bg-accent'}">
            <ul data-fx-json="${tab_names}" data-modal_title="${type}">
              ${strMap((tab) => {
                const { name } = tab;
                if (name) {
                  return `<li data-title="${name}" class="list ${
                    selected_name.trim() === name.trim() ? 'selected' : ''
                  }">${name}</li>`;
                } else {
                  return `<li data-title="${tab}" class="list ${
                    selected_name === tab ? 'selected' : ''
                  }">${tab}</li>`;
                }
              }, tab_names)}
              ${is_mobile ? html`<li class="spacer"></li>` : ''}
            </ul>
          </div>
          <div class="modal_content">
            <div>
              ${content({
                type,
                tab_names,
                selected_name,
                tabs,
                bp_id,
                bp_name,
              })}
            </div>
          </div>
        </div>
      `;
    };
  });
};
